const CampanaTypes = {
  UPDATE_USER_POINTS: "UPDATE_USER_POINTS"
};

export default CampanaTypes;
